var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{staticClass:"input-style text-right",class:_vm._class,attrs:{"autocomplete":"off","size":_vm.size,"formatter":_vm.formatter,"placeholder":_vm.placeholder,"disabled":_vm.disabled},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }